import { MDBTable, MDBTableBody } from "mdbreact";
import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

function SocialDataModal({ modal, toggleCriteria }) {
  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggleCriteria}
        style={{ maxWidth: "800px" }}
        centered
      >
        <ModalHeader toggle={toggleCriteria}>
          <h5 style={{ fontWeight: "bold" }}>Social Data Criteria</h5>
        </ModalHeader>
        <ModalBody>
          <table className="table table-bordered">
            <MDBTableBody>
              <tr>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Item
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Criteria
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Score
                </th>
              </tr>

              <tr>
                <td>Posts on Reel</td>
                <td>
                  <tr>Agri Relevant</tr>
                  <tr>Irrelevant</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>

              <tr>
                <td>Advisory Sessions</td>
                <td>
                  <tr>Loan Crop Relevant</tr>
                  <tr>Other Crop Relevant</tr>
                  <tr>Other Advisories</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>3</tr>
                  <tr>2</tr>
                  <tr>1</tr>
                </td>
              </tr>

              <tr>
                <td>In App Purchases</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>

              <tr>
                <td>In App Sales</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>
            </MDBTableBody>
          </table>
        </ModalBody>
        {/* <ModalFooter> */}
        {/* <Button color="secondary" onClick={toggleCriteria}>
            Cancel
          </Button> */}
        {/* </ModalFooter> */}
      </Modal>
    </>
  );
}

export default SocialDataModal;
